import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Protected = (props) => {
    const IS_LOGGED_IN = localStorage.getItem('IS_LOGGED_IN');  // =null if deleted
    const navigate = useNavigate();

    useEffect(() => {
        if(!IS_LOGGED_IN || IS_LOGGED_IN === 'false') {
            navigate('/');
        }
    }, []);
    return (
        <>
           {props.component}
        </>
    );
}

export default Protected;
